module.exports = __webpack_public_path__ + "static/media/ico5.70893478.png";